/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  RewardConfigUpdateDTO,
  RewardSharePreviewDTO
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 批量保存打赏参数（整批原子，关键参数必填改动理由）
 */
const rewardConfigUpdate = (
    rewardConfigUpdateDTO: RewardConfigUpdateDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rewardConfigUpdateDTO
    },
      );
    }
  /**
 * @summary 刷新参数缓存（处置「缓存与库不一致」，会改变运行时实际生效值）
 */
const rewardConfigRefreshCache = (

 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/config/refresh-cache`, method: 'POST'
    },
      );
    }
  /**
 * @summary 分账预览（按假设费率逐档试算，标出会被资损闸门拒掉的档位）
 */
const rewardConfigPreview = (
    rewardSharePreviewDTO?: RewardSharePreviewDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/config/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rewardSharePreviewDTO
    },
      );
    }
  /**
 * @summary 查询打赏参数列表（含库值与运行时生效值）
 */
const rewardConfigList = (

 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/config/list`, method: 'GET'
    },
      );
    }
  /**
 * @summary 打赏参数自检（只读：越界/费率上限/环境一致性/缓存一致性/超限覆盖）
 */
const rewardConfigCheck = (

 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/config/check`, method: 'GET'
    },
      );
    }
  return {rewardConfigUpdate,rewardConfigRefreshCache,rewardConfigPreview,rewardConfigList,rewardConfigCheck}};
export type RewardConfigUpdateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardConfigUpdate']>>>
export type RewardConfigRefreshCacheResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardConfigRefreshCache']>>>
export type RewardConfigPreviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardConfigPreview']>>>
export type RewardConfigListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardConfigList']>>>
export type RewardConfigCheckResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardConfigCheck']>>>
